import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RoutesShortWandP } from 'src/app/models/const';
import { AuthService } from '../services/auth.service';

export const MaintenanceGuardService: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return new Observable<boolean>((observer) => {
    authService.getMaintenanceMode().subscribe((result) => {
      if (!!result) {
        router.navigateByUrl(RoutesShortWandP.Maintenance);
        authService.resetUser();
      }
      observer.next(true);
      observer.complete();
    });
  });
};
